@if (isLoading()) {
<div class="flex justify-center items-center h-screen bg-white">
  <lib-bouncing-loader [message]="'SNDBX OS'" />
</div>
} @else {
<div class="min-h-screen bg-white flex flex-col">
  <!-- Header -->
  <lib-portal-header />

  <!-- Main Content -->
  <main class="flex-1 py-12 px-4 sm:px-6 lg:px-8 bg-white">
    <div class="max-w-6xl mx-auto space-y-8">
      <!-- Navigation Grid -->
      <div class="animate-slideInUp" style="animation-delay: 200ms">
        <lib-navigation-grid [firstName]="getFirstName()" />
      </div>
    </div>
  </main>
</div>
}
